import React from 'react';
import projects from '../../Projects/projects';
import ProjectCard from './ProjectCard';

const Projects = () => {
    let key = 0;
    return (
        <section className="project-container mt-5 pb-5 mw-100" id="projects">
            <div data-aos="slide-right" className="caption mb-5" style={{ color: '#2294b1' }}>Projects</div>
            <div data-aos="slide-left" className="row d-flex justify-content-center flex-wrap mw-100 pl-5 pt-4 pb-4">
                {
                    projects.map(project => <ProjectCard project={project} key={++key} />)
                }
            </div>
        </section>
    );
};

export default Projects;